import { useSearchParams, useNavigate } from "react-router-dom";

export default function PaymentFail() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const message = searchParams.get("message") || "결제 처리 중 문제가 발생했습니다.";

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#FFF8F0] via-white to-[#FFF0E6] flex items-center justify-center px-6">
      <div className="w-full max-w-md text-center">
        <div className="bg-white rounded-3xl shadow-xl p-10">
          <div className="w-20 h-20 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-6">
            <i className="ri-close-line text-4xl text-red-600"></i>
          </div>

          <h1 className="text-2xl font-medium text-gray-800 mb-2">
            결제에 실패했습니다
          </h1>
          <p className="text-sm text-gray-500 mb-8">{message}</p>

          <div className="space-y-3">
            <button
              onClick={() => navigate("/order")}
              className="w-full bg-[#2D2D2D] text-white py-4 rounded-xl font-medium hover:bg-[#1a1a1a] transition-all cursor-pointer"
            >
              다시 시도하기
            </button>
            <button
              onClick={() => navigate("/")}
              className="w-full bg-gray-100 text-gray-600 py-4 rounded-xl font-medium hover:bg-gray-200 transition-all cursor-pointer"
            >
              홈으로 돌아가기
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
